import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const concludeCheckoutAbTest = {
  name: "concludeCheckoutAbTest" as const,
  input: z.object({
    splitId: zExt.objectId(),
    selectedTreatmentId: zExt.objectId(),
  }),
  output: z.null(),
};
